import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import {
  Button,
  Typography,
  Card,
  Checkbox,
  List,
  Row,
  Col,
  DatePicker,
  Input,
  Slider,
  Form,
  Badge,
  Tooltip,
} from "../../common/utils/antd-imports/AntdImports";
import { ReactComponent as CalenderIcon } from "../../../assests/cuida_calendar-outline.svg";
import { ReactComponent as CloseIcon } from "../../../assests/close-icon.svg";
import DMAList from "../dma-list/DmaList";
import qs from "query-string";
import "./ProductFilters.css";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import {
  setFilterChecks,
  setProductTypes,
  setDateRange,
  setSelectedSizes,
  clearAllFilters,
  setInComeSliderValue,
  setPagination,
  setSearchText,
  setFiltersApplied,
  clearSelectedState,
  clearAllFiltersApllied,
  clearUserInteracted,
  clearMapCamera,
  clearSelectedStateId,
  setMapView,
  setMapIncomeSliderValue,
  setShapeOfMap,
} from "../../../store/slices/common-slice/product-filters/ProductFilter";
import { getFilterProducts } from "../../../store/thunks/common-thunks/commonThunk";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as SearchIcon } from "../../../assests/search-icon.svg";
import { clearSelectedDMAs } from "../../../store/thunks/common-thunks/Actions";
import { debounce } from "lodash";
import { RightOutlined } from "@ant-design/icons";

const { Text } = Typography;
const FILTER_BUTTONS = ["Date", "DMA", "Product Type", "Price", "Size"];

const ProductFilters = ({
  showNearby,
  location,
  searchText,
  onFilterPayload,
}) => {
  const { channelData, sizeList, maxPrice, minPrice } = useSelector(
    (state) => state.products,
  );
  const productTypeRef = useRef(null);
  const sizeRef = useRef(null);
  const hasMounted = useRef(false);
  const restrictRef = useRef(null);
  const dateRef = useRef(null);
  const priceRef = useRef(null);
  const dmaRef = useRef(null);
  // Debounced fetch for searchText
  const searchDidMountRef = useRef(false);
  const [searchParams] = useSearchParams();
  const selectedDMAs = useSelector((state) => state.dma.selectedDMAs);

  const {
    filterChecks,
    inComeSliderValue,
    productTypes,
    selectedDateRange,
    selectedSizes,
    dmaList,
    selectedState,
    shapeOfMap,
    zoomOnMap,
    mapIncomeSliderValue,
    userInteracted,
  } = useSelector((state) => state.filters);
  let pageFromURL = parseInt(searchParams.get("page")) || 1;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTab1 = useMediaQuery({ maxWidth: 768 });
  const [activeFilter, setActiveFilter] = useState(null);
  const [filtersHydrated, setFiltersHydrated] = useState(false);
  const [searchProductTypeByTitle, setSearchProductTypeByTitle] = useState({});
  const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });
  const [hoveredItem, setHoveredItem] = useState(null);
  const buttonRefs = useRef({});
  const prevSizesRef = useRef();

  const dmaIds = useMemo(
    () => selectedDMAs?.map((item) => item?.id).filter(Boolean) || [],
    [selectedDMAs],
  );
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const hydrationCompletedRef = useRef(false);
  const allIds = useMemo(() => {
    return Object.values(filterChecks)
      ?.flat()
      ?.map((item) => {
        if (typeof item === "string") {
          try {
            return JSON.parse(item)?.id;
          } catch (e) {
            return null;
          }
        }
        return item?.id;
      })
      ?.filter(Boolean);
  }, [filterChecks]);
  const dateCount = selectedDateRange?.from || selectedDateRange?.to ? 1 : 0;
  const sizeCount = Array.isArray(selectedSizes) ? selectedSizes.length : 0;
  const [selectedItem, setSelectedItem] = useState(null);
  const filterCounts = {
    DMA: selectedDMAs?.length,
    "Product Type": Object?.values(filterChecks)?.flat()?.length,
    Date: dateCount,
    Size: sizeCount,
    Restrictions: 0, // If applicable
  };
  const [stateSelected, setStateSelected] = useState(() => {
    return localStorage.getItem("STATE_SELECTED") === "true";
  });
  const parsedQuery = useMemo(() => {
    return qs.parse(location.search);
  }, [location.search]);
  const hasUrlDmas = !!parsedQuery.dmas;
  useEffect(() => {
    const parsed = qs.parse(location.search);

    // PRODUCT TYPES
    if (parsed.types) {
      const typeIds = parsed.types.split(",");
      dispatch(setProductTypes(typeIds.map(Number)));
    } else {
      dispatch(setProductTypes([])); // reset if missing
    }

    if (parsed.sizes) {
      dispatch(setSelectedSizes(parsed.sizes.split(",")));
    } else {
      dispatch(setSelectedSizes([]));
    }

    if (parsed.from || parsed.to) {
      dispatch(
        setDateRange({
          from: parsed.from || null,
          to: parsed.to || null,
        }),
      );
    }
    // else {
    //   dispatch(setDateRange({ from: null, to: null }));
    // }

    if (parsed.price) {
      const [min, max] = parsed.price.split(",").map(Number);
      dispatch(setInComeSliderValue([min, max]));
    } else {
      dispatch(setInComeSliderValue([minPrice || 0, maxPrice || 0]));
    }

    hydrationCompletedRef.current = true;
  }, [location.search]);
  //controlling text overflow or not
  const checkOverflow = (el, id) => {
    if (el) {
      const isOverflow = el.scrollWidth > el.clientWidth;

      setIsOverflowing((prev) => {
        // prevent unnecessary re-renders
        if (prev[id] === isOverflow) return prev;

        return {
          ...prev,
          [id]: isOverflow,
        };
      });
    }
  };
  useEffect(() => {
    // If state NOT selected → normal behavior
    if (!stateSelected && !hasUrlDmas) {
      if (minPrice != null && maxPrice != null) {
        if (
          Number(inComeSliderValue?.[0]) !== Number(minPrice) ||
          Number(inComeSliderValue?.[1]) !== Number(maxPrice)
        ) {
          dispatch(setInComeSliderValue([minPrice, maxPrice]));
        }
      }
      return;
    }

    // State selected + DMA exists
    if (Array.isArray(selectedDMAs) && selectedDMAs.length > 0) {
      dispatch(setInComeSliderValue([0, 600000]));
      return;
    }

    // State selected + no DMA
    if (minPrice != null && maxPrice != null && stateSelected) {
      if (
        Number(inComeSliderValue?.[0]) !== Number(minPrice) ||
        Number(inComeSliderValue?.[1]) !== Number(maxPrice)
      ) {
        dispatch(setInComeSliderValue([minPrice, maxPrice]));
      }
    }
  }, [stateSelected, selectedDMAs, minPrice, maxPrice, dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isDatePickerPopup = event.target.closest(".ant-picker-dropdown");
      if (
        (activeFilter === "Product Type" &&
          productTypeRef.current &&
          !productTypeRef.current.contains(event.target)) ||
        (activeFilter === "Size" &&
          sizeRef.current &&
          !sizeRef.current.contains(event.target)) ||
        (activeFilter === "Restrictions" &&
          restrictRef.current &&
          !restrictRef.current.contains(event.target)) ||
        (activeFilter === "Price" &&
          priceRef.current &&
          !priceRef.current.contains(event.target)) ||
        (activeFilter === "Date" &&
          dateRef.current &&
          !dateRef.current.contains(event.target) &&
          !isDatePickerPopup) ||
        (activeFilter === "DMA" &&
          dmaRef.current &&
          !dmaRef.current.contains(event.target))
      ) {
        setActiveFilter(null);
      }
    };

    if (
      activeFilter === "Product Type" ||
      activeFilter === "Size" ||
      activeFilter === "Restrictions" ||
      activeFilter === "Date" ||
      activeFilter === "Price" ||
      activeFilter === "DMA"
    ) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeFilter]);

  const handleIncomeInputChange = (index, e) => {
    let newValue = [...inComeSliderValue];
    newValue[index] = Number(e.target.value) || "";
    dispatch(setInComeSliderValue(newValue));
  };
  const handleCheckboxChange = (itemTitle, filterItem, checked) => {
    const existing = filterChecks[itemTitle] || [];
    let updated;

    if (checked) {
      updated = [...existing, { id: filterItem?.id, label: filterItem?.label }];
      dispatch(setFiltersApplied(true));
    } else {
      updated = existing.filter((f) => {
        const parsed = typeof f === "string" ? JSON.parse(f) : f;
        return parsed.id !== filterItem.id;
      });
    }

    const updatedChecks = {
      ...filterChecks,
      [itemTitle]: updated,
    };

    dispatch(setFilterChecks(updatedChecks));

    const hasAnySelected = Object.values(updatedChecks).some(
      (arr) => arr?.length > 0,
    );

    dispatch(setFiltersApplied(hasAnySelected));

    const allSelected = [];
    for (const key in updatedChecks) {
      updatedChecks[key]?.forEach((item) => allSelected?.push(item.id));
    }
    dispatch(setProductTypes(allSelected));
  };

  const updateDateRange = (key, date) => {
    dispatch(setInComeSliderValue(["", ""]));
    dispatch(
      setDateRange({
        ...selectedDateRange,
        [key]: date?.format("YYYY-MM-DD"),
      }),
    );
  };

  const handleButtonClick = (key) => {
    const btn = buttonRefs.current[key];
    if (btn) {
      const rect = btn.getBoundingClientRect();
      setPopoverPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
      setActiveFilter((prev) => (prev === key ? null : key));
      setHoveredItem(null);
    }
  };

  const handleFiltersProducts = useCallback(
    (page, isPagination = false) => {
      const isSearch = !searchText;
      const shouldSendPrices =
        isPagination ||
        (!selectedDMAs.length && !selectedSizes.length && !searchText);

      const sendEmptyPrices = isSearch && !isPagination;
      const payload = showNearby
        ? {
            page_no: "",
            page_size: "",
            product_type: allIds,
            product_fromPrice:
              isPagination && inComeSliderValue?.[0] !== null
                ? String(inComeSliderValue[0])
                : "",

            product_toPrice:
              isPagination && inComeSliderValue?.[1] !== null
                ? String(inComeSliderValue[1])
                : "",

            booked_from: selectedDateRange?.from,
            booked_to: selectedDateRange?.to,
            size: selectedSizes,
            radiusSearch: {
              latitude: location?.latitude || 34.05,
              longitude: location?.longitude || -118.25,
              radius: 5,
            },
            search_param: searchText || "",
            product_dma: [],
          }
        : {
            page_no: page,
            page_size: 8,
            product_type: allIds,
            product_fromPrice: sendEmptyPrices
              ? ""
              : shouldSendPrices && inComeSliderValue?.[0] !== null
                ? String(inComeSliderValue[0])
                : "",
            product_toPrice: sendEmptyPrices
              ? ""
              : shouldSendPrices && inComeSliderValue?.[1] !== null
                ? String(inComeSliderValue[1])
                : "",
            booked_from: selectedDateRange?.from,
            booked_to: selectedDateRange?.to,
            size: selectedSizes,
            search_param: searchText || "",
            product_dma: dmaIds,
            ...(selectedState &&
              selectedDMAs?.length <= 0 && {
                state_name_map: selectedState,
              }),
            ...(shapeOfMap &&
              selectedDMAs?.length <= 0 && {
                shape: shapeOfMap,
              }),
            ...(selectedDMAs?.length <= 0 && {
              zoom_in_level: zoomOnMap,
            }),
          };

      if (window.innerWidth >= 800) {
        onFilterPayload?.(payload);
        dispatch(getFilterProducts(payload));
      }
      if (!isTab1) {
        navigate(
          {
            search: qs.stringify({
              ...qs.parse(window.location.search),
              page: page,
            }),
          },
          { replace: true },
        );
      }
    },
    [
      showNearby,
      productTypes,
      inComeSliderValue,
      selectedDateRange,
      selectedSizes,
      location,
      searchText,
      dmaIds,
      allIds,
      dispatch,
      getFilterProducts,
      isTab1,
      navigate,
    ],
  );
  // Debounced fetch for searchText
  const debouncedFetchProducts = useMemo(
    () => debounce(() => handleFiltersProducts(1, false), 500),
    [handleFiltersProducts],
  );

  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!searchDidMountRef.current) {
      searchDidMountRef.current = true;
      return;
    }
    debouncedFetchProducts();
    return () => debouncedFetchProducts.cancel();
  }, [searchText]);
  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!filtersHydrated) {
      setFiltersHydrated(true);
    } else if (filtersHydrated) {
      handleFiltersProducts(1, false);
    }
    // eslint-disable-next-line
  }, [productTypes, selectedDMAs]);

  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!filtersHydrated) {
      setFiltersHydrated(true);
      return;
    }

    if (
      JSON.stringify(prevSizesRef.current) === JSON.stringify(selectedSizes)
    ) {
      return;
    }
    prevSizesRef.current = selectedSizes;
    handleFiltersProducts(1, false);
  }, [selectedSizes]);
  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    // Only run on updates (not on first render)
    handleFiltersProducts(pageFromURL, true);
  }, [pageFromURL]);

  const handleInComeSliderChange = useCallback(
    (value) => {
      dispatch(setInComeSliderValue(value));
    },
    [dispatch],
  );

  const handleTextChange = useCallback(
    (value) =>
      value ? value.replace(value[0], value[0].toUpperCase()) : value,
    [],
  );
  const applyFilters = () => {
    if (
      activeFilter === "Date" &&
      !selectedDateRange?.from &&
      !selectedDateRange?.to
    ) {
      return;
    }
    handleFiltersProducts(1, true);
    setActiveFilter(null);
    dispatch(setFiltersApplied(true));
  };
  const clearAll = () => {
    dispatch(clearUserInteracted());
    dispatch(clearAllFilters());
    dispatch(setSelectedSizes([""]));
    dispatch(setProductTypes([]));
    dispatch(clearSelectedDMAs());
    dispatch(setSelectedSizes([]));
    dispatch(setFiltersApplied());
    dispatch(clearAllFiltersApllied());
    dispatch(clearSelectedState());
    localStorage.removeItem("STATE_SELECTED");
    dispatch(clearMapCamera());
    dispatch(clearSelectedStateId());
    dispatch(setShapeOfMap());
    dispatch(setProductTypes([]));
    dispatch(setDateRange());
    dispatch(clearUserInteracted(null));
    sessionStorage.removeItem("PAGINATION_ACTIVE");
    sessionStorage.removeItem("mapZoomVal");
  };
  const renderDmaList = () => (
    <Card title={popoverTitle} style={{ width: 700 }}>
      <Row>
        <DMAList />
      </Row>
    </Card>
  );
  const renderDatePicker = () => (
    <>
      <Card title="Dates" style={{ width: 350 }}>
        <Row gutter={16} className="filter-date-picker">
          <Col span={12}>
            <DatePicker
              bordered={false}
              placeholder="From"
              value={
                selectedDateRange?.from
                  ? dayjs(selectedDateRange?.from, "YYYY-MM-DD")
                  : null
              }
              onChange={(date) => updateDateRange("from", date)}
              suffixIcon={<CalenderIcon />}
              popupClassName="end-date-calendar"
            />
          </Col>
          <Col span={12}>
            <DatePicker
              bordered={false}
              placeholder="To"
              value={
                selectedDateRange?.to
                  ? dayjs(selectedDateRange?.to, "YYYY-MM-DD")
                  : null
              }
              onChange={(date) => updateDateRange("to", date)}
              suffixIcon={<CalenderIcon />}
              popupClassName="end-date-calendar"
            />
          </Col>
        </Row>
        <Row justify="end">
          <Button
            onClick={applyFilters}
            style={{ backgroundColor: "#d2042d", borderColor: "#d2042d" }}
          >
            <Text style={{ fontSize: 14, color: "#fff" }}>Apply </Text>
          </Button>
        </Row>
      </Card>
    </>
  );

  const renderPriceFilter = () => (
    <>
      <Card title="Prices" style={{ width: 350 }}>
        <Row className="budget-input" gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item>
              <Input
                className="rfp-input-field"
                type="number"
                onWheel={(e) => e.target.blur()}
                inputMode="decimal"
                pattern="[0-9]*"
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="From"
                value={inComeSliderValue[0]}
                onChange={(e) => handleIncomeInputChange(0, e)}
                prefix="$"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <Input
                className="rfp-input-field"
                type="number"
                onWheel={(e) => e.target.blur()}
                inputMode="decimal"
                pattern="[0-9]*"
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="To"
                value={inComeSliderValue[1]}
                onChange={(e) => handleIncomeInputChange(1, e)}
                prefix="$"
              />
            </Form.Item>
          </Col>
        </Row>
        <div className="slider-parent">
          <Slider
            range
            value={inComeSliderValue}
            min={minPrice}
            max={maxPrice}
            onChange={handleInComeSliderChange}
            trackStyle={{ backgroundColor: "red" }}
            tooltip={{ open: false }}
          />
        </div>
        <Row justify="end">
          <Button onClick={applyFilters} style={{ backgroundColor: "#d2042d" }}>
            <Text style={{ fontSize: 14, color: "#fff" }}>Apply </Text>
          </Button>
        </Row>
      </Card>
    </>
  );

  const renderProductType = () => {
    return (
      <Card className="product-type-filter-card">
        <List
          dataSource={channelData
            ?.slice()
            ?.sort((a, b) => a.title.localeCompare(b?.title))}
          renderItem={(item) => {
            const isOpen = selectedItem?.id === item?.id;

            const searchValue = searchProductTypeByTitle?.[item?.title] || "";

            const filteredFilters = item?.filter?.filter((f) =>
              f.label.toLowerCase().includes(searchValue.toLowerCase()),
            );

            return (
              <>
                {/* HEADER ROW */}
                <List.Item
                  key={item?.id}
                  onClick={() => setSelectedItem(isOpen ? null : item)}
                  className="product-type-list-items"
                >
                  <Col
                    span={16}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <>
                      {/* DOT */}
                      <span
                        className="dot"
                        style={{
                          backgroundColor: item?.color_code,
                        }}
                      />
                      {isOverflowing[item?.id] ? (
                        <Tooltip title={item?.title}>
                          <Text
                            ref={(el) => checkOverflow(el, item?.id)}
                            className="truncate"
                          >
                            {item?.title}
                          </Text>
                        </Tooltip>
                      ) : (
                        <Text
                          ref={(el) => checkOverflow(el, item?.id)}
                          className="truncate"
                        >
                          {item?.title}
                        </Text>
                      )}
                    </>
                  </Col>

                  <Col span={2}>
                    {filterChecks?.[item?.title]?.length > 0 && (
                      <Badge
                        count={filterChecks[item?.title].length}
                        size="small"
                        style={{ backgroundColor: "#d2042d" }}
                      />
                    )}
                  </Col>

                  <Col span={2}>
                    <RightOutlined rotate={isOpen ? 90 : 0} />
                  </Col>
                </List.Item>

                {/* COLLAPSE CONTENT */}
                {isOpen && (
                  <div className="inner-collapse-section">
                    <Input
                      placeholder="Search Product Type"
                      variant="filled"
                      className="search-f-loc"
                      prefix={<SearchIcon />}
                      style={{ height: 40, marginBottom: "8px" }}
                      allowClear
                      value={searchValue}
                      onChange={(e) =>
                        setSearchProductTypeByTitle((prev) => ({
                          ...prev,
                          [item.title]: e.target.value,
                        }))
                      }
                    />

                    {filteredFilters?.map((f) => (
                      <List key={f.id}>
                        <List.Item className="details-section-list">
                          <Checkbox
                            checked={
                              Array.isArray(filterChecks[item?.title])
                                ? filterChecks[item?.title].some((val) => {
                                    const parsed =
                                      typeof val === "string"
                                        ? JSON.parse(val)
                                        : val;
                                    return parsed?.id === f?.id;
                                  })
                                : false
                            }
                            onChange={(e) =>
                              handleCheckboxChange(
                                item?.title,
                                f,
                                e.target.checked,
                              )
                            }
                          >
                            <span
                              className="dot"
                              style={{
                                backgroundColor: item?.color_code,
                              }}
                            />
                            <Text className="filter-lbels-txt">{f?.label}</Text>
                            <span className="filter-products-count">
                              ({f?.product_count})
                            </span>
                          </Checkbox>
                        </List.Item>
                      </List>
                    ))}
                  </div>
                )}
              </>
            );
          }}
        />
      </Card>
    );
  };

  const popoverTitle = (
    <Row>
      <Col span={22}>
        <Text className="loc-popover-title">More Locations</Text>
      </Col>
      <Col span={2}>
        <CloseIcon
          onClick={() => setActiveFilter(null)}
          style={{ cursor: "pointer" }}
        />
      </Col>
    </Row>
  );

  const renderFilterCardContent = () => {
    switch (activeFilter) {
      case "DMA":
        return renderDmaList();
      case "Product Type":
        return renderProductType();
      case "Price":
        return renderPriceFilter();
      case "Date":
        return renderDatePicker();

      case "Size":
        return (
          <Card title="Size" className="filter-parent-card-section">
            <Checkbox.Group
              options={sizeList?.map((item) => handleTextChange(item?.label))}
              value={selectedSizes}
              onChange={(val) => {
                // Update Redux filterChecks for Size
                const updated = sizeList
                  ?.filter((item) => val.includes(item?.label))
                  ?.map((item) => ({ id: item.id, label: item?.label }));

                dispatch(
                  setFilterChecks({
                    ...filterChecks,
                    // Size: updated,
                  }),
                );
                dispatch(setFiltersApplied(true));
                dispatch(setSelectedSizes(val));
              }}
              className="collapse-pannel-checkbox"
            />
          </Card>
        );
      case "Restrictions":
        return (
          <Card title="Restrictions" className="filter-parent-card-section">
            <Row justify="end">
              <Button
                className="apply-filters"
                onClick={() => setActiveFilter(null)}
              >
                Apply
              </Button>
            </Row>
          </Card>
        );
      default:
        return null;
    }
  };

  // --- Hydrate filters from URL on mount ---
  useEffect(() => {
    if (!channelData || !sizeList || !dmaList) return;

    const params = Object.fromEntries([...searchParams]);

    const newFilterChecks = {};
    if (params.types) {
      const typeIds = params.types.split(",");
      const allTypeOptions = channelData.flatMap((c) => c.filter);

      typeIds.forEach((id) => {
        const found = allTypeOptions.find(
          (opt) => String(opt.id) === String(id),
        );

        if (found) {
          const channel = channelData.find((c) =>
            c.filter.some((f) => String(f.id) === String(id)),
          );

          if (channel) {
            if (!newFilterChecks[channel.title])
              newFilterChecks[channel.title] = [];

            newFilterChecks[channel.title].push({
              id: found.id,
              label: found.label,
            });
          }
        }
      });
    }
    if (params.sizes) {
      const sizeLabels = params.sizes.split(",");
      // Commented this code because it was adding size into filterchecks and causing incorrect Product Type behavior In UI
      // const sizeArr = sizeList.filter((item) =>
      //   sizeLabels.includes(item.label),
      // );

      // newFilterChecks["Size"] = sizeArr.map((item) => ({
      //   id: item.id,
      //   label: item.label,
      // }));

      dispatch(setSelectedSizes(sizeLabels));
    }

    if (params.dmas) {
      const dmaIds = params.dmas.split(",");
      const dmaArr = dmaList.filter((item) => dmaIds.includes(String(item.id)));

      dispatch({
        type: "dma/setSelectedDMAs",
        payload: dmaArr.map((item) => ({
          id: item.id,
          label: item.city_name,
        })),
      });
    }
    dispatch(setFilterChecks(newFilterChecks));
  }, [channelData, sizeList, dmaList, searchParams]);

  return (
    <div className="filters-btns">
      {FILTER_BUTTONS?.map((label) => {
        const count = filterCounts[label];
        const labelWithCount = count > 0 ? `${label} (${count})` : label;

        return (
          <Button
            key={label}
            className="filter-btn-at-map-section"
            onClick={() => handleButtonClick(label)}
            ref={(el) => (buttonRefs.current[label] = el)}
            style={{ marginRight: 10 }}
            disabled={showNearby ? label === "DMA" : false}
          >
            {labelWithCount}
          </Button>
        );
      })}

      <Button onClick={clearAll} className="filter-btn-at-map-section">
        <Text>Clear All</Text>
      </Button>

      {activeFilter && (
        <div
          ref={
            activeFilter === "Product Type"
              ? productTypeRef
              : activeFilter === "Size"
                ? sizeRef
                : activeFilter === "Restrictions"
                  ? restrictRef
                  : activeFilter === "Date"
                    ? dateRef
                    : activeFilter === "Price"
                      ? priceRef
                      : activeFilter === "DMA"
                        ? dmaRef
                        : null
          }
          className="filters-render-filter-css"
          style={{
            top: popoverPos.top / 5,
            left:
              activeFilter !== "Restrictions"
                ? popoverPos.left / 1.5
                : popoverPos.left / 1.3,
          }}
        >
          {renderFilterCardContent()}
        </div>
      )}
    </div>
  );
};

export default ProductFilters;
